import { lazy, ComponentType } from 'react';

// Retry failed dynamic imports (chunk load errors)
export function lazyWithRetry<T extends ComponentType<any>>(
  componentImport: () => Promise<{ default: T }>
): React.LazyExoticComponent<T> {
  return lazy(async () => {
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      window.sessionStorage.getItem('page-has-been-force-refreshed') || 'false'
    );

    try {
      const component = await componentImport();
      window.sessionStorage.setItem('page-has-been-force-refreshed', 'false');
      return component;
    } catch (error: any) {
      if (!pageHasAlreadyBeenForceRefreshed && error.name === 'ChunkLoadError') {
        // Deployment happened, chunks changed, refresh the page
        window.sessionStorage.setItem('page-has-been-force-refreshed', 'true');
        window.location.reload();
        
        // Return a dummy component while reloading
        return { default: (() => null) as unknown as T };
      }
      
      // For other errors, retry the import once
      try {
        return await componentImport();
      } catch (retryError) {
        console.error('Failed to load module after retry:', retryError);
        
        // If still failing and it's a network error, try one more reload
        if (!pageHasAlreadyBeenForceRefreshed && 
            (retryError instanceof TypeError && retryError.message.includes('Failed to fetch'))) {
          window.sessionStorage.setItem('page-has-been-force-refreshed', 'true');
          window.location.reload();
          return { default: (() => null) as unknown as T };
        }
        
        throw retryError;
      }
    }
  });
}